import React, { useState } from "react";

import FundingReadinessCard from "../FundingReadinessCard";

const SEGMENTS = [
  { key: "funding", label: "Funding Readiness" },
  { key: "offers", label: "Offers" },
];

const LoanHome = () => {
  const [segment, setSegment] = useState("funding");

  return (
    <div className="flex flex-col gap-4">
      <div className="flex justify-center">
        <div className="inline-flex rounded-full bg-white p-1 shadow-sm" role="tablist">
          {SEGMENTS.map(({ key, label }) => (
            <button
              key={key}
              role="tab"
              aria-selected={segment === key}
              onClick={() => setSegment(key)}
              className={`px-6 py-2 rounded-full font-semibold text-sm transition-colors ${
                segment === key ? "bg-blue-600 text-white" : "text-gray-600 hover:bg-gray-100"
              }`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
      {segment === "funding" ? (
        <FundingReadinessCard />
      ) : (
        <div className="flex justify-center items-center bg-white rounded-3xl shadow-md h-60 px-6 text-center text-gray-500">
          We're preparing your funding options.
        </div>
      )}
    </div>
  );
};

export default LoanHome;
